export default "__VITE_ASSET__to5poPEB__"